


















import Vue from "vue";
import { Component } from "vue-property-decorator";
import registerHf from "@/services/registerHf";

@Component({})
export default class Report extends Vue {
  message = `Klik tautan di bawah ini untuk melaporkan kerusakan/ pertanyaan terkait aplikasi RME atau komputer di ruangan Anda:`;
  nb = `NB: Bila link tersebut tidak bekerja, laporan dapat dilakukan dengan kirim chat ke WA-Gateway SIMRS di nomor: 089510778377 (format: #laporsim <spasi> pesan)`;
}
